import config from "../app.json";
import axios from "axios";

import { Row, Col } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import PlanInfo from "./PlanInfo";
import CheckoutReview from "./CheckoutReview";
import PaymentInfo from "./PaymentInfo";
import AllIncluded from "./AllIncluded";
import AlertComponent from "../Components/AlertComponent";
import "../Assets/Css/index.scss";

import CsWhiteLogo from "../Assets/Svgs/cs-white-logo.svg";
import AwsLogo from "../Assets/Svgs/aws-logo.svg";

const SelectPlan = (props) => {
  const { upgradePlan, currentPlan, setPlanOutside } = props;
  const [optionSelected, setOptionSelected] = useState(null);
  const [finalPrice, setFinalPrice] = useState(0);
  const [planDescription, setPlanDescription] = useState(null);
  const [planMonthlyFee, setPlanMonthlyFee] = useState(0);
  const [planId, setPlanId] = useState(null);
  const [setupFee, setSetupFee] = useState(null);
  const [allPlans, setAllPlans] = useState([]);
  const [currentPricePerSeat, setCurrentPricePerSeat] = useState(0);
  const [coupon, setCoupon] = useState(null);

  useEffect(() => {
    axios
      .post(config.API + "/api/Plan/getPlans")
      .then((res) => {
        if (res.status === 200 && res.data) {
          const data = res.data.$values;
          const index = data.findIndex((item) => item.name === currentPlan);
          if (index !== -1) {
            setCurrentPricePerSeat(data[index].pricePerSeat);
            data.splice(index, 1);
          }
          setAllPlans(data);
        }
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error || error?.message,
          { icon: `error` }
        );
      });
  }, [0]);

  const handlePlanSelection = (id) => {
    const selectedPlan = allPlans.filter((x) => x.id == id)[0];
    setOptionSelected(id);
    setPlanDescription(selectedPlan.name);
    setPlanMonthlyFee(selectedPlan.value);
    setSetupFee(selectedPlan.setupFee);
    const chargePrice = selectedPlan.value + selectedPlan.setupFee;
    setFinalPrice(chargePrice);
    setPlanId(id);

    if (setPlanOutside) {
      setPlanOutside({ ...selectedPlan, chargePrice: chargePrice });
    }
  };

  let minValueIndex = allPlans.reduce((minIndex, element, currentIndex) => {
    return element.pricePerSeat < allPlans[minIndex].pricePerSeat
      ? currentIndex
      : minIndex;
  }, 0);

  let currentPricePerSeatOpt = currentPricePerSeat;
  if (!upgradePlan && allPlans.length) {
    const orderedPlanList = [...allPlans.sort((x) => x.pricePerSeat)];
    minValueIndex = Math.round(orderedPlanList.length / 2 - 1);
  }

  var bestOption = allPlans[minValueIndex];
  if (currentPricePerSeat === 0 && bestOption) {
    currentPricePerSeatOpt = bestOption.pricePerSeat;
    setCurrentPricePerSeat(currentPricePerSeatOpt);
  }
  const bestPriceId =
    bestOption &&
      currentPricePerSeat > 0 &&
      bestOption.pricePerSeat <= currentPricePerSeatOpt
      ? bestOption.id
      : 0;

  return (
    <div
      className={!upgradePlan ? `prelogin-container` : `select-plan-container`}
    >
      <div
        className={!upgradePlan ? `containerLoginForm` : `containerselectplan`}
      >
        {!upgradePlan && (
          <Row className="header-login">
            <Col className="col-md-6">
              <img className="cs-logo-login" src={CsWhiteLogo} />
            </Col>
            <Col className="col-md-6">
              <img className="aws-logo-login" src={AwsLogo} />
            </Col>
          </Row>
        )}
        <Row>
          <Col className="col-md-12">
            <Row>
              {!upgradePlan && (
                <Col className="col-md-4">
                  <AllIncluded />
                </Col>
              )}
              <Col className="col-md-8">
                <Row>
                  {allPlans.map((x, index) => (
                    <Col className={!upgradePlan ? `col-md-4` : `col-md-5`} key={"item_plan_" + index + "_" + x.id}>
                      <PlanInfo
                        id={x.id}
                        iconColor={x.id === bestPriceId ? "#FA9804" : "#FBBD05"}
                        title={x.name}
                        seats={x.seats}
                        monthly={x.value}
                        pricePerSeat={x.pricePerSeat}
                        selected={optionSelected}
                        onSelect={handlePlanSelection}
                      />
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        {!upgradePlan && (
          <Row>
            <Col className="col-md-5 pt-1">
              <CheckoutReview
                setupFee={setupFee}
                planDescription={planDescription}
                planPrice={planMonthlyFee}
                totalPrice={finalPrice}
                coupon={coupon}
              />
            </Col>
            <Col className="col-md-7 pt-4">
              <PaymentInfo
                setupFee={setupFee}
                planDescription={planDescription}
                planPrice={planMonthlyFee}
                planId={planId}
                totalPrice={finalPrice}
                updateCoupon={setCoupon}
              />
            </Col>
          </Row>
        )}
      </div>
    </div>
  );
};
export default SelectPlan;
